import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { NuevoComponentService } from 'src/app/servicios/nuevo-component.service';
import { CellEditorPrueba } from 'src/app/advantage/config/cell-edit-prueba';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { VenEncfacImp } from "../veninterfaces/venfacimp";
import { VenimpfacturasService } from "../venservicios/venimpfacturas.service";
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';//CDPJ
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-venimpfacturas',
  templateUrl: './venimpfacturas.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class VenimpfacturasComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef
  SER_CODIGO = ''
  SER_NOMBRE = '';
  //BUSQUEDA
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  consulta: string;
  displayDialogBusqueda: boolean;
  index = 0;
  indicador: any;
  //ag-grid
  largo: string;
  defaultDetfacimp
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle
  vendetfacimp: VenEncfacImp[] = [];
  // importar 
  datosJson: any[] = []
  spin

  columnDefsDetfacimp = [
    {
      headerName: 'Num Factura', field: 'ENCFAC_NUMERO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Código Cli.', field: 'RUC_CEDULA', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Nombre Cli.', field: 'RAZON_SOCIAL', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Fecha Emisión', field: 'FECHA', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Total factura', field: 'TOTAL', cellEditor: 'cellPrueba', width: 150, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      }

    },
  ]

  constructor(
    private busqService: InvbusquedaService, private init: NuevoComponentService, private auditoriagral: AuditoriagralService,
    private messageService: MessageService, public venimpfacturasService: VenimpfacturasService, private datePipe: DatePipe,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyle = (params) => {
      if (params.data.FACEXISTE === 'SI') {
        return { background: '#FFFAAD' };
      }
    };
    this.defaultDetfacimp = {
      editable: true,
      width: 100,
      objeto: 'detvenfacimp',
      resizable: true
    };

  }
  ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.largo = '-2800';

  }
  manejarSenales(valor) {
    if (valor === 'Excel') {
      this.inputfile.nativeElement.click();
    }
    if (valor === 'Visto') {
      this.procesarfacturas();
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }


  }
  async procesarfacturas() {
    try {
      this.spin = true;
      for (const iterator of this.vendetfacimp) {
        if (iterator.FACEXISTE === 'NO') {
          const data = await this.venimpfacturasService.procesarfacturas(iterator)
        }
        
      }
      this.messageService.add({
        key: 'venimpfac',
        severity: 'success',
        summary: 'Éxito',
        detail: 'Las facturas se crearon de forma exitosa'
      });
      this.spin = false
    } catch (error) {
      this.messageService.add({
        key: 'venimpfac',
        severity: 'error',
        summary: 'Error',
        detail: ' Hubo un error al crear las facturas '+ error
      });
      this.spin = false
      return;
     
    }
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    this.spin = true
    const reader = new FileReader();
    const file = ev[0];
    try {
      reader.onload = async (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

        jsonData = workBook.SheetNames.reduce((initial, name) => {
          console.log(workBook.Sheets[name]);
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          return initial;
        }, {});
        //console.log(jsonData.Hoja1);

        for (let data of jsonData.Hoja1) {

          delete data.__EMPTY;
          for (let key in data) { // se revisa los campos del json generado del excel,
            // si uno de esos campos no existe o está vacío no se activará el boton de guardar
            if (data[key] === '') {
              validacionVacio = false;
            }

          }
        }
        this.datosJson = jsonData.Hoja1;
        //console.log(this.datosJson)
        this.inputfile.nativeElement.value = ''

        await this.validaexcell();

      }
      reader.readAsBinaryString(file);
    } catch (error) {
      this.messageService.add({
        key: 'venimpfac',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al leer los datos del archivo'
      });
      this.spin = false
      return;
    }
  }
  async validaexcell() {
    try {
      for (const item of this.datosJson) {
        item.NUMERO = this.completarceros(item.NUMERO)
        item.FACEXISTE = 'NO'
        item.FECHA = isNullOrUndefined(item.FECHA) || item.FECHA === '' ? '' : this.datePipe.transform(item.FECHA, 'dd/MM/yyyy')
        if (item.FECHA === '') {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'El campo FECHA no puede estar vacío '
          });
          this.spin=false
          return;
        }
        item.COD_SERVICIO=isNullOrUndefined(item.COD_SERVICIO) || item.COD_SERVICIO=== ''?this.SER_CODIGO:item.COD_SERVICIO

      }
      const cedulas = Array.from(new Set(this.datosJson.map(item => String(item.RUC_CEDULA))));
      const estabpuntoemi = Array.from(new Set(this.datosJson.map(item => String(item.ESTABLECIMIENTO + item.PUNTO_EMISION))));
      const numfac = Array.from(new Set(this.datosJson.map(item => String(item.ESTABLECIMIENTO + item.PUNTO_EMISION + item.NUMERO))));
      const vendedor = Array.from(new Set(this.datosJson.map(item => String(item.COD_VENDEDOR))));
      const servicios = Array.from(new Set(this.datosJson.map(item => String(item.COD_SERVICIO))));
      const cencostos = Array.from(new Set(this.datosJson.map(item => String(item.CENTRO_COSTOS))));

      const data1 = await this.venimpfacturasService.validacedulas(cedulas);
      const data2 = await this.venimpfacturasService.validavendedores(vendedor);
      const data3 = await this.venimpfacturasService.validaencfac(numfac, estabpuntoemi);
      const data4 = await this.venimpfacturasService.getnemonicos(estabpuntoemi);
      const data5 = await this.venimpfacturasService.validaservicios(servicios)
      const data6 = await this.venimpfacturasService.validacencostos(cencostos)

    if (data1 !== null && data1 !== undefined) {
        if (data1.length > 0) {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar las siguiente cédulas, por favor revisar ' + data1.join(", ")
          });
          this.spin = false
          return;
        }
      }
      if (data2 !== null && data2 !== undefined) {
        if (data2.length > 0) {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes vendedores, por favor revisar ' + data2.join(", ")
          });
          this.spin = false
          return;
        }
      }
      if (data4 !== null && data4 !== undefined) {
        if (data4.length === 0) {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los puntos de emisión y establecimientos, por favor revisar '
          });
          this.spin = false
          return;
        } else {
          for (const item of this.datosJson) {
            for (let index = 0; index < data4.length; index++) {
              const element = data4[index];
              if (element.NUM_SERIE === item.ESTABLECIMIENTO + item.PUNTO_EMISION) {
                item.ENCFAC_NUMERO = data4[index].NUM_NEMONICO + item.ESTABLECIMIENTO + item.PUNTO_EMISION + item.NUMERO
              }
            }
          }
        }
      }
      if (data3 !== null && data3 !== undefined) {
        if (data3.length > 0) {
          //for (const iterator of this.datosJson) {
          for (let index = 0; index < data3.length; index++) {
            const element = data3[index].ENCFAC_NUMERO;
            // console.log(iterator)
            console.log(element.toString().slice(-15))
            const indice = this.datosJson.findIndex(item => (item.ESTABLECIMIENTO + item.PUNTO_EMISION + item.NUMERO) === element.toString().slice(-15))
            console.log(indice)
            if (indice !== -1) {
              this.datosJson[indice].FACEXISTE = 'SI'
            }

          }
          //}
        }
      }
      if (data5 !== null && data5 !== undefined) {
        if (data5.length > 0) {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes servicios, por favor revisar ' + data5.join(", ")
          });
          this.spin = false
          return;
        }
      }
      if (data6 !== null && data6 !== undefined) {
        if (data6.length > 0) {
          this.messageService.add({
            key: 'venimpfac',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes centros de costos, por favor revisar ' + data6.join(", ")
          });
          this.spin = false
          return;
        }
      }
      console.log(this.datosJson)
      // console.log(cedulas)
      // console.log(estabpuntoemi)
      // console.log(numfac)
      //--- INSERTAR FACTURA
      this.cargaencfac()
    } catch (error) {
      this.messageService.add({
        key: 'venimpfac',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al validar los datos del archivo por favor revise ' + error
      });
      this.spin = false
      console.log(error)
      return;
    }

  }
  async cargaencfac() {
    this.vendetfacimp = this.datosJson
    this.messageService.add({
      key: 'venimpfac',
      severity: 'success',
      summary: 'Éxito',
      detail: 'El archivo se cargó con éxito'
    });
    this.spin = false
  }
  completarceros(cadena) {
    try {
      let longcadena = cadena.toString().length
      let dif = 0;
      let fincadena = '';
      dif = 9 - longcadena
      if (longcadena === 9) {
        return cadena
      } else {
        for (let index = 0; index < dif; index++) {
          fincadena += '0'
        }
        fincadena = fincadena + cadena
      }
      return fincadena
    } catch (error) {
      console.log(error)
      return ''
    }

  }
  changeTabs() {

  }
  busquedaservicio(parametro) {
    this.opcionbusqueda = 'servicioventas'
    this.types = [
      { label: 'Código', value: 'SER_CODIGO' },
      { label: 'Descripción', value: 'SER_DESCRIPCION' },
      { label: 'Código Contable', value: 'CON_CODIGO' },
      { label: 'Precio', value: 'SER_PRECIO' },
      { label: 'IVA', value: 'SER_TRIBUTAIVA' }
    ];
    this.busquedacampos = [parametro, '', '', '', ''];
    this.consulta = '*';
    this.tabla = 'VEN_MAESERVICIO';
    this.where = '';

    this.busqService.encontrarRegistro4(parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busqService.busquedaTabla(this.consulta, this.tabla, this.where).subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.displayDialogBusqueda = true;
          });

        }
      } else {
        this.busqService.busquedaTabla(this.consulta, this.tabla, this.where).subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.displayDialogBusqueda = true;
        });
      }
    });
  }
  manejarSeleccion(opcion) {
    this.SER_CODIGO = opcion.SER_CODIGO
    this.SER_NOMBRE = opcion.SER_DESCRIPCION

    this.displayDialogBusqueda = false;
  }
  botonesmodificar() {

  }
  setFocus(valor) {

  }
  cambio(evento) {

  }
  seleccionItem(params) {

  }
}
